export const CHANNEL_CREATE = 'MODAL/CHANNEL_CREATE'
export const CHANNEL_CLONE = 'MODAL/CHANNEL_CLONE'
export const CHANNEL_SETTINGS = 'MODAL/CHANNEL_SETTINGS'
export const MOVE_TO = 'MODAL/MOVE_TO'
export const NOTES_HISTORY = 'MODAL/NOTES_HISTORY'
export const NOTES_SHARE_TO_SLACK = 'MODAL/NOTES_SHARE_TO_SLACK'
export const CHANNEL_ONBOARDING = 'MODAL/CHANNEL_ONBOARDING'
export const INVITE_OAUTH_MEMBERS = 'MODAL/INVITE_OAUTH_MEMBERS'
export const IMPORT_FILES = 'MODAL/IMPORT_FILES'
export const FILE_LIMIT_EXCEEDED = 'MODAL/FILE_LIMIT_EXCEEDED'
export const NOTES_INFOS = 'MODAL/NOTES_INFOS'
export const SLACK_INVITE = 'MODAL/SLACK_INVITE'
export const SHORTCUTS = 'MODAL/SHORTCUTS'
export const DESKTOP_REDIRECTION = 'MODAL/DESKTOP_REDIRECTION'
export const NOTIFICATIONS_CENTER = 'MODAL/NOTIFICATIONS_CENTER'
export const TEMPLATE_PICKER = 'MODAL/TEMPLATE_PICKER'
export const PAYMENT_INCENTIVE = 'MODAL/PAYMENT_INCENTIVE'
